import { Routes, mapToCanActivate, mapToResolve } from '@angular/router';

import { WorkflowBuilderComponent } from "./components/workflow/workflow-builder.component";
import { WorkflowImportComponent } from "./components/workflow/workflow-import.component";
import { FlowTemplateResolver } from "./resolvers/flow-template.resolver";
import { StateBuilderComponent } from './components/state/state-builder.component';
import { BaseGuardService } from '../auth/guards/base-guard.service';
import { SystemPermissionGuardService } from '../auth/guards/system-permission-guard.service';
import { LunaClaimValues } from '../models/user-identity.model';
import { ExpressionTestComponent} from "./components/expression-test/expression-test.component";

const routeGuards = [BaseGuardService, SystemPermissionGuardService];

export const BUILDER_ROUTES: Routes = [
  {
    path: "flow/:id",
    component: WorkflowBuilderComponent,
    resolve: { template: FlowTemplateResolver },
    canActivate: mapToCanActivate(routeGuards),
    data: { permission: LunaClaimValues.ManageWorkflows }
  },
  {
    path: "flow/:id/states/:stateKey",
    component: StateBuilderComponent,
    resolve: { template: mapToResolve(FlowTemplateResolver) },
    canActivate: mapToCanActivate(routeGuards),
    data: { permission: LunaClaimValues.ManageWorkflows }
  },
  {
    path: "flow/:id/states/:stateKey/:majorVersion/:minorVersion",
    component: StateBuilderComponent,
	resolve: { template: mapToResolve(FlowTemplateResolver) },
    canActivate: mapToCanActivate(routeGuards),
    data: { permission: LunaClaimValues.ManageWorkflows }
  },
  {
    path: "flow/import/:moduleGroupId/:moduleId",
    component: WorkflowImportComponent,
    canActivate: mapToCanActivate(routeGuards),
    data: { permission: LunaClaimValues.ManageWorkflows }
  }  ,
  {
    path: "flow/:id/:moduleGroupId/:moduleId",
    component: WorkflowBuilderComponent,
	resolve: { template: mapToResolve(FlowTemplateResolver) },
    canActivate: mapToCanActivate(routeGuards),
    data: { permission: LunaClaimValues.ManageWorkflows }
  },
  {
    path: "expression-test",
    component: ExpressionTestComponent,
    canActivate: mapToCanActivate(routeGuards),
    data: { permission: LunaClaimValues.ManageWorkflows }
  },
  
];
